/**
 * Der Taktgeber der Wiedergabe.
 *
 * Die Vorschau meldet hier an, welches Medienelement gerade den Ton angibt;
 * die Transportleiste fragt bei jedem Bild nach. Läuft ein Video, folgt der
 * Kopf dessen eigener Uhr -- dann kann er ihr nicht davonlaufen, und niemand
 * muss den Abstand mit einem Sprung ausgleichen. Läuft keines (nur Text, nur
 * Ton, oder das Bild lädt noch), gibt die Wanduhr den Takt, wie bisher.
 */

/** Liefert die Stelle auf der Zeitleiste, oder null, wenn niemand taktet. */
export type Taktgeber = () => number | null;

let taktgeber: Taktgeber | null = null;

export function setzeTaktgeber(geber: Taktgeber | null): void {
  taktgeber = geber;
}

export function taktZeit(): number | null {
  if (!taktgeber) return null;
  const t = taktgeber();
  return t === null || !Number.isFinite(t) ? null : t;
}
